import type { SeriesMetadata } from '@/components/Chart/types/chartData';

const getUnitSuffix = (custom: Partial<SeriesMetadata>): string => {
  if (!custom.Currency || !custom.Units) return '';
  return ` (${custom.Currency}/${custom.Units})`;
};

export default getUnitSuffix;
